//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ElLottie from '@/components/UI/el-lottie'
import { mapState } from 'vuex'

export default {
  name: 'LearnSection',
  components: {
    ElLottie,
  },
  data() {
    return {
      learnTopAnimationFirst: {
        container: '.learn__top-animation-img',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/learn-top.json`,
      },
      learnTopAnimationSecond: {
        container: '.learn__top-animation-img--second',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/learn-top-2.json`,
      },
      learnAnimationFirst: {
        container: '.learn__el-img--first',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/learn-1.json`,
      },
      learnAnimationSecond: {
        container: '.learn__el-img--second',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/learn-2.json`,
      },
      learnAnimationThird: {
        container: '.learn__el-img--third',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/learn-3.json`,
      },
    }
  },
  computed: {
    ...mapState(['i18n']),
    isSnakeAllowed() {
      return this.i18n.locale === 'ru'
    },
    isFrontend() {
      return this.$route.path.split('/').pop() === 'frontend'
    },
  },
  methods: {
    showIcon(routes) {
      return routes.includes(this.$route.path.split('/').pop())
    },
  },
}
